import React, { useState } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';

const EditFeaturedModal = ({ isOpen, setIsOpen, fetchData, editId, formData, setFormData }) => {
   
    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const handleStatusChange = (selectedOption) => {
        setFormData(prev => ({
            ...prev,
            status: selectedOption ? selectedOption.value : ""
        }));
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const url = `${process.env.REACT_APP_LINK}/categoryfeature/change-category/${editId}`;
            const response = await fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
            if (response.ok) {
                fetchData(); // Refresh the data after successful submission
                toast.success('Category updated successfully!', {
                    position: 'top-center',
                    autoClose: 2000,
                });

                // setEditId(null);
                setFormData({ category: '', status: '', position: '', user_id: isLoggedIn.user_id });
                setIsOpen(false); // Close modal after submission
            } else {
                toast.error('Failed to update category', {
                    position: 'top-center',
                    autoClose: 2000,
                });
                console.error('Failed to submit form');
            }
        } catch (error) {
            toast.error('Error occurred while updating category', {
                position: 'top-center',
                autoClose: 2000,
            });
            console.error('Error:', error);
        }
    }


    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];

    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div
                className="custom-modal-content"
                onClick={(e) => e.stopPropagation()} // Prevent closing on content click
            >
                <h2 className="oms-modal-title">Home Category</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    <div className="oms-form-group">
                        <label htmlFor="service" className="oms-form-label">
                            Category
                        </label>
                        <input type="text" name='category' id="service" value={formData.category} placeholder="Enter Category" onChange={handleChange} required/>
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="status" className="oms-form-label">
                            Status
                        </label>
                        <Select options={statusOptions}
                            placeholder="Select status"
                            value={statusOptions.find(option => option.value === formData.status)}
                            onChange={handleStatusChange} 
                            required
                            />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="service" className="oms-form-label">
                            Position
                        </label>
                        <input type="text" id="service" name='position' placeholder="Enter Position" value={formData.position} onChange={handleChange} required/>
                    </div>
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        <button type="submit">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditFeaturedModal;
